import { useEffect } from 'react';
import { useConfig, useLogout } from '@kega/sps-core';

import { t } from '../../lib/translations';

import useGeoIp from "../../hooks/useGeoIp";
import useCustomerCountry from '../../hooks/customer/useCustomerCountry';

import Modal from '../../components/modal/Modal';
import LinkButton from '../../components/buttons/LinkButton';

import classes from './CountryNotice.module.css'

const CustomerCountryNotice = ({ onUserLoggedOut }) => {
    const config = useConfig();
    const { popupShownFlag, setPopupShownFlag, isCountryInStoreViews } = useGeoIp();
    const { authenticatedUserCountry } = useCustomerCountry();
    const logout = useLogout();

    const storeViews = config.get('storeViews');
    const storeCode = config.get('storeCode');
    const storeviewCountry = storeViews[storeCode].country;

    const sameCountry = storeviewCountry?.toUpperCase() === authenticatedUserCountry;
    const isNetherlands = authenticatedUserCountry === 'NL';

    useEffect(() => {
        
        if (!popupShownFlag && authenticatedUserCountry && (!sameCountry && isCountryInStoreViews(authenticatedUserCountry))) {
            setPopupShownFlag(true);
        }

    }, [storeviewCountry, popupShownFlag, authenticatedUserCountry])

    const handleStay = () => {
        logout();
        setPopupShownFlag(false);
        onUserLoggedOut();
    };

    const handleNavigate = () => {
        const targetPath = isNetherlands ? '/nl_nl' : '/be_nl';
        window.location.href = targetPath;
        setPopupShownFlag(false);
    }

    return (
        <Modal open={popupShownFlag && !sameCountry} onClose={() => null} contentStyle={classes.modal}>
            <div className={classes.root}>
                <h2 className={classes.title}>{t('country_notice.title', { country: isNetherlands ? 'Nederland' : 'België' })}?</h2>
                <div className={classes.stay_on_wrapper} onClick={handleStay}>
                    <img src={`/images/${storeviewCountry}.svg`} className={classes.flag}/>
                    <p className={classes.stay_on_text}>
                        {t('country_notice.paragraph', { country: isNetherlands ? 'Belgische' : 'Nederlandse' })} {`(${t('country_notice.logged_out')})`}
                    </p>
                </div>
                <LinkButton 
                    className={classes.button} 
                    variant='primary'
                    onClick={handleNavigate} 
                >
                    <img src={`/images/${authenticatedUserCountry?.toLowerCase()}.svg`} className={classes.flag} />
                    {t('country_notice.button', { country: isNetherlands ? 'Nederlandse' : 'Belgische' })}
                </LinkButton>
                
            </div>
        </Modal>
    )
    
}

export default CustomerCountryNotice;